export default {
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    branchoffices: [
        {id: -1, name: 'TODOS SEPARADO POR SEDE - BODEGA'},
        {id: -2, name: 'TODOS CONSOLIDADO'}
    ],
    lots_info: [
        {id: -1, name: 'DETALLADO POR LOTES'},
        {id: -2, name: 'CONSOLIDADO'},
    ],
    branchoffices_warehouses: [],
    lines: [],
    brands: [],
    preloader: false,
    loading: {
        module:false,
    },
    params: {
        date: new Date(),
        branchoffice_id: -1,
        branchoffice_warehouse_id: null,
        line_id: null,
        brand_id: null,
        info_lots_id: -1,
        download: null
    },
    data_report:[]
};



// WEBPACK FOOTER //
// ./src/modules/inventory-report/state.js